import { getSummaryDashboards } from '@apis'
import { useQuery } from '@tanstack/react-query'
import { BaseResponseSPCG, SummaryDashboard } from '@types'
import { AxiosResponse } from 'axios'

import { adminDashboardQueryKeys } from './adminDashboardQueryKeys'

const ONE_HOUR = 1000 * 60 * 60

const useGetAdminDashboardList = () => {
  return useQuery({
    queryFn: getSummaryDashboards,
    queryKey: adminDashboardQueryKeys.list(),
    select: (response: AxiosResponse<BaseResponseSPCG<SummaryDashboard[]>>) => response.data.result,
    staleTime: ONE_HOUR,
    refetchInterval: ONE_HOUR,
  })
}

export default useGetAdminDashboardList
